export const OTP_DEFAULT_CODE_LENGTH = 6;
export const OTP_RESEND_COOLDOWN_SECONDS = 60;
export const OTP_AUTO_CLOSE_DELAY_MS = 2000;

